import { BT } from "./bt-devices"
import { Plusnet } from "./plusnet-devices"
import { Sky } from "./sky-devices"
import { Virgin } from "./virgin-devices"
import { Vodafone } from "./vodafone-devices"

export const devices = {
  phone: [BT, Plusnet, Sky, Virgin, Vodafone],
  SIMO: [
    {
      id: "SIMO",
      img: "images/devices/sim.png",
      name: "SIM Only",
      rating: 0
    }
  ]
}
